// Fetch all businesses API
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const fetchallCategoriesapi = async (page = 1, limit = 12) => {
  try {
    const res = await fetch(
      `${BASE_URL}/allbusinesscategories?page=${page}&limit=${limit}`,
      {
        cache: "no-store",
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    const results = await res.json();

    if (!res.ok) {
      throw new Error(results.error || "Failed to fetch categories");
    }

    return results;
  } catch (err) {
    console.error("Fetch API error:", err);
    throw err;
  }
};

//fetch single category by categoryId
export const fetchSingleCategoryByIdapi = async (
  categoryIds: string[] | string,
) => {
  try {
    const ids = Array.isArray(categoryIds)
      ? [...new Set(categoryIds)]
      : [categoryIds];
    const joinedIds = ids.join(",");

    const res = await fetch(`${BASE_URL}/fetchsinglecategory/${joinedIds}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch category");
    }

    const data = await res.json();
    return data.categories || [];
  } catch (error) {
    console.error("Error fetching single category", error);
    return [];
  }
};
//Fetch businesses by categoryId
export const fetchBizbyCategoryIdapi = async (
  categoryId: string,
  page: number = 1,
  limit: number = 9,
) => {
  try {
    const res = await fetch(
      `${BASE_URL}/business/businessbycategoryId?categoryId=${encodeURIComponent(
        categoryId,
      )}&page=${page}&limit=${limit}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        cache: "no-store",
      },
    );

    if (!res.ok) {
      throw new Error(`Failed to fetch business by category: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching business", error);
    return null;
  }
};

export const addCategoryApi = async (
  categoryname: string,
  slug: string,
  token: string,
) => {
  try {
    const res = await fetch(`${BASE_URL}/addcategory`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ categoryname, slug }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Failed to add category");
    }

    return data;
  } catch (error) {
    console.error("Error adding category:", error);
    return null;
  }
};

//delete-api to delete category
export const deleteCategoryApi = async (categoryId: string, token: string) => {
  try {
    const res = await fetch(
      `${BASE_URL}/addcategory/editcategory/${categoryId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Failed to delete category");
    }

    return result;
  } catch (error) {
    console.error("Error deleting category:", error);
    throw error;
  }
};
